import request from './request';
import env from '../../utils/env';

export const getBoxStatus = () => request(`${env.boxApi}/boxes/self/box-state`);
